export default __webpack_public_path__ + "static/media/Video-image1.9dcb6ccd.jpeg";